module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_bluehole.1ad0976289e9954447cde3bf3a8d06bf.png";